import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LiveList from "@/pages/live/page";
import LiveDetail from "@/pages/live/detail/page";
import About from "@/pages/about/page";
import Faq from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "live",
        element: <LiveList />,
      },
      {
        path: "live/:id",
        element: <LiveDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "faq",
        element: <Faq />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;